import { createSelector } from '@reduxjs/toolkit';
import {
  selectAllPlacements,
  selectPlacementsForFile,
  selectImagePlacementsByFloorplan,
} from 'store/floorplanPlacements/selectors/floorplanPlacements.selectors';

const selectFloorplansState = (state) => state.floorplans;

const selectFloorplansEntityState = createSelector(
  [selectFloorplansState],
  (state) => state.floorplans
);

export const selectFloorplansLoading = createSelector(
  [selectFloorplansState],
  (state) => state.loading
);

export const selectSelectedFloorplanId = createSelector(
  [selectFloorplansState],
  (state) => state.selectedFloorplanId
);

export const selectFloorplanUploadProgress = createSelector(
  [selectFloorplansState],
  (state) => state.uploadProgress
);

export const selectFloorplanSelectionRect = createSelector(
  [selectFloorplansState],
  (state) => state.selectionRect
);

export const selectProjectFloorplansArray = createSelector(
  [selectFloorplansEntityState],
  (floorplans) => Object.values(floorplans.entities)
);

export const selectSelectedFloorplan = createSelector(
  [selectProjectFloorplansArray, selectSelectedFloorplanId],
  (floorplans, selectedId) => floorplans.find((fp) => fp.id === selectedId)
);

export const selectFloorplanPlacementsArray = createSelector(
  [selectAllPlacements],
  (placements) => placements
);

export const selectFloorplanPlacementsForFloorplan = (state, floorplanId) =>
  selectImagePlacementsByFloorplan(state, floorplanId);

export const selectFloorplanPlacementsForFile = (state, filePermissionId) =>
  selectPlacementsForFile(state, filePermissionId);
